// extracted by mini-css-extract-plugin
module.exports = {"content":"tab-documents_content__381eU"};